<template>
  <div class="about-page-wrap">
    <div class="about-header">
      <div class="about-header-title" v-cloak>
        <h3 :class="{ cn: locale === 'cn' }">{{ $t('about.head_title') }}</h3>
        <p :class="{ cn: locale === 'cn' }" v-html="$t('about.head_txt')"></p>
      </div>

    </div>

    <div class="about-body">
      <div class="about-team">
        <h3>{{ $t('about.team_header') }}</h3>
        <p :class="{ cn: locale === 'cn' }">{{ $t('about.team_txt') }}</p>
      </div>

      <div class="about-priorities">
        <h3>{{ $t('about.priorities_header') }}</h3>

        <h4>{{ $t('about.trustworthy_header') }}</h4>
        <p :class="{ cn: locale === 'cn' }">{{ $t('about.trustworthy_txt') }}</p>

        <h4>{{ $t('about.accessbile_header') }}</h4>
        <p :class="{ cn: locale === 'cn' }">{{ $t('about.accessbile_txt') }}</p>

        <h4>{{ $t('about.professional_header') }}</h4>
        <p :class="{ cn: locale === 'cn' }">{{ $t('about.professional_txt') }}</p>
      </div>

    </div>

    <div class="download-logo">
      <div class="container">
        <h3>{{ $t('about.download_logo') }}</h3>
        <div class="logo-wrapper">
          <span class="white-version">
            <img src="~/assets/img/about/logo-op-white-h.png" />
            <a :href="whiteLogo" target="_blank" download="logo_white.png">
              <span class="download" v-html="$t('about.download_png')" />
            </a> </span
          ><span class="green-version">
            <img src="~/assets/img/about/Logo4.png" />
            <a :href="logo" target="_blank" download="logo_color.png">
              <span class="download" v-html="$t('about.download_png')" />
            </a>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { useI18n } from "vue-i18n";
import { mapState } from '~/common/js/patch';
import WhiteLogo from '~/assets/img/about/logo-op-white-h.png';
import Logo from '~/assets/img/about/Logo4.png';

// import { transLang } from '~/common/js/utils'
// import { axiosClient } from '~/common/js/axios'
export default {
  computed: {
    ...mapState({
      locale: (state) => state.locale,
    }),
    recruitUrl() {
      if (this.locale == 'cn') {
        return '/recruit_cn';
      } else {
        return '/recruit';
      }
    },
  },
  data() {
    return {
      CareersList: [],
      whiteLogo: WhiteLogo,
      logo: Logo
    };
  },
  async mounted() {
    const self = this;
    const anchor = self.$route.query.bitmart_careers;

    self.$nextTick(() => {
      if (anchor) {
        window.scrollTo(0, 1500);
      }
    });

    // const timestamp = new Date().getTime()
    // const params = {
    //   lang: transLang(self.locale),
    //   timestamp,
    //   chnl: 'web',
    // }
    // const ret = await axiosClient({
    //   method: 'GET',
    //   url: '/gw-api/api/v3/careers',
    //   params,
    // })

    // if (ret?.success) {
    //   self.CareersList = ret.data.jobs
    // }
  },
  head() {
    return {
      meta: [
        { name: 'build-date', content: process.env.BUILD_DATE },
        { name: 'build-commit', content: process.env.release },
      ],
    };
  },
  setup() {
    const { tm } = useI18n();
    return {
      tm,
    }
  }
};
</script>

<style lang="less">
@import '../../../common/css/theme.less';

.about-page-wrap {
  .about-header {
    background: url('~/assets/img/about/about_header_bg.jpg') no-repeat 100% 100%;
    background-color: black;
    background-size: 1680px;
    height: 650px;
    color: #fff;
    .about-header-title {
      padding-top: 128px;
      width: 1180px;
      margin: 0 auto;
      h3 {
        text-align: left;
        margin-bottom: 28px;
        letter-spacing: -0.34px;
        line-height: 36px;
        font-size: 36px;
        text-shadow: 0 2px 10px #000000;
        width: 600px;
        font-weight: normal;
        &.cn {
          width: auto;
        }
      }
      p {
        text-align: left;
        width: 900px;
        line-height: 20px;
        font-size: 14px;
        margin-bottom: 40px;
        font-weight: 300;
        &.cn {
          line-height: 24px;
        }
      }
    }
    .about-header-content {
      width: 1180px;
      margin: 122px auto 0;
      background: #fff;
      .tit {
        font-size: 30px;
        font-weight: bold;
        margin-bottom: 15px;
      }
      .contents {
        display: flex;
        justify-content: space-between;
        text-align: center;
        width: 900px;
        margin: 0 auto;
        .content {
          padding: 28px 25px;
          h3 {
            font-size: 36px;
            font-weight: normal;
            color: #000;
          }
          p {
            font-size: 14px;
            line-height: 1.5;
            color: #000;
          }
        }
      }
    }
  }

  .about-body {
    background: #fff;
    padding-top: 92px;
    padding-bottom: 80px;
    .about-team {
      width: 1180px;
      margin: 0 auto;
      h3 {
        font-size: 30px;
        color: #040404;
        letter-spacing: -0.72px;
        margin-bottom: 45px;
        font-weight: normal;
      }
      p {
        font-size: 14px;
        color: #050505;
        letter-spacing: -0.34px;
        line-height: 20px;
        &.cn {
          line-height: 26px;
        }
      }
    }
    .about-priorities {
      width: 1180px;
      margin: 92px auto 70px;
      h3 {
        font-size: 30px;
        color: #040404;
        letter-spacing: -0.72px;
        margin-bottom: 45px;
        font-weight: normal;
      }
      h4 {
        font-size: 20px;
        margin-top: 40px;
        font-weight: normal;
      }
      p {
        font-size: 14px;
        color: #050505;
        letter-spacing: -0.34px;
        line-height: 20px;
        &.cn {
          line-height: 26px;
        }
      }
    }
    .office-location {
      width: 1180px;
      margin: 80px auto 92px;
      h3 {
        font-size: 30px;
        color: #040404;
        letter-spacing: -0.72px;
        margin-bottom: 65px;
        font-weight: normal;
      }
      .office-wrap {
        display: flex;
        justify-content: space-between;
        .offices {
          width: 280px;
          .background {
            background-color: black;
            width: 280px;
            height: 153px;
            &.new-york-bg {
              background: url('~/assets/img/about/about_newyork.jpg') no-repeat 100% 100%;
              background-size: cover;
            }
            &.china-bg {
              background: url('~/assets/img/about/about_china.jpg') no-repeat 100% 100%;
              background-size: cover;
            }
            &.seoul-bg {
              background: url('~/assets/img/about/about_seoul.jpg') no-repeat 100% 100%;
              background-size: cover;
            }
            &.hongkong-bg {
              background: url('~/assets/img/about/about_hongkong.jpg') no-repeat 100% 100%;
              background-size: cover;
            }
          }
          .city-sec {
            text-align: center;
            padding: 23px;
            background: #000;
            color: #fff;
            font-size: 14px;
            font-weight: 300;
            .iconfont2 {
              font-size: 14px;
              display: inline-block;
              vertical-align: bottom;
              &.cn {
                font-size: 16px;
              }
            }
          }
        }
      }
    }
    .careers {
      width: 1180px;
      margin: 70px auto 92px;
      h3 {
        font-size: 30px;
        color: #040404;
        letter-spacing: -0.72px;
        margin-bottom: 65px;
        font-weight: normal;
      }
      .el-collapse {
        .el-collapse-item {
          .el-collapse-item__header {
            position: relative;
            .el-collapse-item__arrow {
              display: none;
            }
          }
          h4 {
            font-size: 14px;
            margin-top: 20px;
            margin-bottom: 20px;
          }
          p {
            font-size: 14px;
          }
          .salary {
            margin-top: 15px;
            margin-bottom: 15px;
          }
          .career-title {
            color: @green_text1;
          }
          .location {
            position: absolute;
            right: 10px;
            .iconfont2 {
              font-size: 14px;
              display: inline-block;
              vertical-align: bottom;
            }
          }
          .hr-email {
            margin-top: 15px;
            font-weight: bold;
          }
          &.is-active {
            .career-title {
              color: #000;
            }
          }
        }
      }
    }
  }

  .download-logo {
    background: url('~/assets/img/about/about_middle_bg.jpg') no-repeat 100% 100%;
    background-color: black;
    background-size: 1680px;
    height: 420px;
    .container {
      width: 1180px;
      margin: 0 auto;
      padding-top: 51px;
      h3 {
        font-size: 30px;
        color: #fff;
        letter-spacing: -0.72px;
        margin-bottom: 55px;
        font-weight: normal;
      }
      .logo-wrapper {
        width: 1180px;
        height: 200px;
        margin: 0 auto;
        .white-version,
        .green-version {
          display: inline-block;
          border: none;
          width: 590px;
          height: 200px;
          position: relative;
          .download {
            position: absolute;
            bottom: 17px;
            right: 20px;
            font-size: 12px;
            letter-spacing: -0.29px;
          }
          img {
            position: absolute;
            left: 50%;
            top: 50%;
            width: 150px;
            transform: translate(-50%, -50%);
          }
        }
        .white-version {
          background: #2c2c2c;
          .download {
            color: #fff;
          }
        }
        .green-version {
          background: #fff;
        }
      }
    }
  }
}

@media (max-width: 1200px) {
  .about-page-wrap {
    .about-header {
      .about-header-title {
        width: 90%;
      }
      .about-header-content {
        width: 90%;
        .contents {
          width: 80%;
        }
      }
    }

    .about-body {
      padding: 0 30px;
      padding-top: 92px;
      padding-bottom: 80px;
      .about-team {
        width: 100%;
      }
      .about-priorities {
        width: 100%;
      }
      .office-location {
        width: 100%;
        .office-wrap {
          display: block;
          text-align: center;
          .offices {
            width: 350px;
            display: inline-block;
            margin-bottom: 40px;
            .background {
              width: 350px;
              height: 191px;
            }
            &:nth-child(odd) {
              margin-right: 50px;
            }
          }
        }
      }
      .careers {
        width: 100%;
      }
    }

    .download-logo {
      .container {
        width: 100%;
        padding: 30px;
        box-sizing: border-box;
        .logo-wrapper {
          width: 100%;
          .white-version,
          .green-version {
            display: inline-block;
            width: 50%;
          }
        }
      }
    }
  }
}

@media (max-width: 900px) {
  .about-page-wrap {
    .about-header {
      .about-header-title {
        p {
          width: 90%;
        }
      }
      .about-header-content {
        width: 90%;
        .contents {
          width: 80%;
        }
      }
    }
    .about-body {
      padding: 0 30px;
      padding-top: 92px;
      padding-bottom: 80px;
      .office-location {
        .office-wrap {
          .offices {
            &:nth-child(odd) {
              margin-right: 0;
            }
          }
        }
      }
      .careers {
        width: 100%;
      }
    }
  }
}

@media (max-width: 768px) {
  .about-page-wrap {
    .about-header {
      height: 420px;
      .about-header-title {
        width: 90%;
        padding-top: 50px;
        h3 {
          max-width: 100%;
          line-height: 20px;
          font-size: 20px;
        }
      }
      .about-header-content {
        width: 90%;
        margin-top: 50px;
        .contents {
          width: 80%;
          .content {
            h3 {
              font-size: 20px;
            }
            p {
              font-size: 14px;
            }
          }
        }
      }
    }

    .about-body {
      padding: 0 30px;
      padding-top: 40px;
      padding-bottom: 40px;
      .about-team {
        h3 {
          font-size: 20px;
          margin-bottom: 20px;
        }
      }
      .about-priorities {
        h3 {
          font-size: 20px;
          margin-bottom: 20px;
        }
        h4 {
          font-size: 16px;
          margin-top: 25px;
        }
      }
      .office-location {
        h3 {
          font-size: 20px;
          margin-bottom: 20px;
        }
      }
      .careers {
        h3 {
          font-size: 20px;
          margin-bottom: 40px;
        }
      }
    }

    .download-logo {
      .container {
        h3 {
          font-size: 20px;
          margin-bottom: 35px;
        }
      }
    }
  }
}

@media (max-width: 640px) {
  .about-page-wrap {
    .about-header {
      height: 600px;
      .about-header-title {
        width: 90%;
        padding-top: 50px;
        h3 {
          &.cn {
            width: 230px;
            line-height: 1.5;
          }
        }
        p {
          width: 100%;
        }
      }
      .about-header-content {
        width: 90%;
        margin-top: 30px;
        .contents {
          width: 80%;
          display: block;
          .content {
            padding: 10px;
          }
        }
      }
    }

    .about-body {
      padding: 0 30px;
      padding-top: 40px;
      padding-bottom: 40px;
      .about-team {
        h3 {
          font-size: 16px;
          margin-bottom: 20px;
        }
        p {
          font-size: 12px;
        }
      }
      .about-priorities {
        h3 {
          font-size: 16px;
          margin-bottom: 20px;
        }
        h4 {
          font-size: 14px;
          margin-top: 25px;
        }
        p {
          font-size: 12px;
        }
      }
      .office-location {
        margin-bottom: 50px;
        h3 {
          font-size: 16px;
          margin-bottom: 20px;
        }
        .office-wrap {
          .offices {
            width: 280px;
            margin-bottom: 25px;
            .background {
              width: 280px;
              height: 153px;
            }
          }
        }
      }
      .careers {
        margin-top: 50px;
        h3 {
          font-size: 16px;
          margin-bottom: 40px;
        }
        .el-collapse {
          .el-collapse-item {
            .career-title {
              line-height: 18px;
              max-width: 200px;
            }
            .location {
              right: 30px;
              font-size: 12px;
            }
            p {
              line-height: 20px;
              font-size: 12px;
            }
          }
        }
      }
    }

    .download-logo {
      .container {
        width: 100%;
        padding: 30px;
        box-sizing: border-box;
        .logo-wrapper {
          width: 100%;
          .white-version,
          .green-version {
            width: 100%;
            height: 150px;
          }
        }
      }
    }
  }
}
</style>
